import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=6b929a5e&"
import script from "./AdminComponent.vue?vue&type=script&lang=js&"
export * from "./AdminComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&id=6b929a5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports